import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import routeConfiguration from '../../../routeConfiguration';
import { createResourceLocatorString } from '../../../util/routes';
import BoxSeparator from '../../BoxSeperator/BoxSeparator';
import Link from '../../Links/Link/Link';

const buttonLinkStyle = { justifyContent: 'space-between' };

const SectionStoryblokPagesComponent = ({ onClose }) => {
  const intl = useIntl();

  return (
    <>
      <BoxSeparator />
      <Stack px={4}>
        <Typography gutterBottom variant="h5">
          <FormattedMessage id="AccountBottomBarBox.seoHeader" />
        </Typography>

        <Button
          color="secondary"
          component={Link}
          fullWidth
          onClick={onClose}
          sx={buttonLinkStyle}
          to={createResourceLocatorString(
            'DumpStationSearchPage',
            routeConfiguration(),
            {},
            {},
            intl.locale
          )}
        >
          <FormattedMessage id="TopbarDesktop.toDumpStationsPage" />
          <ChevronRightIcon color="secondary" />
        </Button>

        <Button
          color="secondary"
          component={Link}
          fullWidth
          onClick={onClose}
          sx={buttonLinkStyle}
          to={createResourceLocatorString(
            'RoutePlannerPage',
            routeConfiguration(),
            {},
            {},
            intl.locale
          )}
        >
          <Box alignItems="center" display="flex">
            <FormattedMessage id="TopbarDesktop.toRoutePlannerPage" />
            <Chip
              label="Beta"
              size="small"
              sx={{
                ml: 1,
                height: 18,
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: 0.5,
                bgcolor: 'secondary.main',
                color: 'secondary.contrastText',
                '& .MuiChip-label': { px: 0.75 },
              }}
            />
          </Box>
          <ChevronRightIcon color="secondary" />
        </Button>

        <Button
          color="secondary"
          component={Link}
          fullWidth
          onClick={onClose}
          sx={buttonLinkStyle}
          to={createResourceLocatorString(
            'StoryblokPage',
            routeConfiguration(),
            { slug: 'wohnmobilstellplatz' },
            {},
            intl.locale
          )}
        >
          <FormattedMessage id="TopbarDesktop.toCamperVanSpots" />
          <ChevronRightIcon color="secondary" />
        </Button>
        <Button
          color="secondary"
          component={Link}
          fullWidth
          onClick={onClose}
          sx={buttonLinkStyle}
          to={createResourceLocatorString(
            'StoryblokPage',
            routeConfiguration(),
            { slug: 'zeltplatz' },
            {},
            intl.locale
          )}
        >
          <FormattedMessage id="TopbarDesktop.toCampsitesPage" />
          <ChevronRightIcon color="secondary" />
        </Button>
        <Button
          color="secondary"
          component={Link}
          fullWidth
          onClick={onClose}
          sx={buttonLinkStyle}
          to={createResourceLocatorString(
            'StoryblokPage',
            routeConfiguration(),
            { slug: 'wohnwagenstellplatz' },
            {},
            intl.locale
          )}
        >
          <FormattedMessage id="TopbarDesktop.toCaravanPage" />
          <ChevronRightIcon color="secondary" />
        </Button>
      </Stack>
    </>
  );
};

SectionStoryblokPagesComponent.displayName = 'SectionStoryblokPages';
const SectionStoryblokPages = memo(SectionStoryblokPagesComponent);
export default SectionStoryblokPages;
